<template>
  <ValidationObserver ref="rejectBookingValidation">
    <BaseDialog :isOpen="isOpen">
      <template v-slot:title>
        Why do you want to reject the role?
      </template>
      <template v-slot:body>
        <div class="reject-booking-request-description">
          <ValidationProvider
            v-slot="{ errors }"
            name="description"
            rules="required"
          >
            <v-textarea
              aria-label="description"
              :error-messages="showValidationErrors ? errors : ''"
              v-model="description"
              required
              class="mt-0"
            />
          </ValidationProvider>
        </div>
      </template>
      <template v-slot:actions>
        <div class="reject-booking-request-actions">
          <PrimaryButton @click.native="cancel" text>
            Cancel
          </PrimaryButton>
          <ErrorButton @click.native="handleSubmit" :loading="isLoading">
            Reject Role
          </ErrorButton>
        </div>
      </template>
    </BaseDialog>
  </ValidationObserver>
</template>

<script>
import BaseDialog from "@/components/common/BaseDialog";
import ErrorButton from "@/components/common/Button/ErrorButton";
import PrimaryButton from "@/components/common/Button/PrimaryButton";
import { createNamespacedHelpers } from "vuex";
import {
  ADD_COMMENT,
  BOOKINGS_NAMESPACE,
  REJECT_BOOKING
} from "@/store/modules/bookings/actions";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { BOOKING_MODEL } from "@/models/booking-model";

const { mapActions } = createNamespacedHelpers(BOOKINGS_NAMESPACE);

export default {
  name: "RejectBookingDialog",
  components: {
    PrimaryButton,
    ErrorButton,
    BaseDialog,
    ValidationObserver,
    ValidationProvider
  },
  data() {
    return {
      showValidationErrors: false,
      description: "",
      isLoading: false
    };
  },
  props: {
    isOpen: Boolean
  },
  inject: ["currentBookingId"],
  methods: {
    ...mapActions({
      rejectBooking: REJECT_BOOKING,
      addComment: ADD_COMMENT
    }),
    async handleSubmit() {
      this.showValidationErrors = true;
      const isFormValid = await this.$refs.rejectBookingValidation.validate();
      if (isFormValid) {
        this.isLoading = true;
        await this.addComment({
          bookingId: this.currentBookingId,
          comment: {
            body: this.description,
            commentableType: BOOKING_MODEL,
            commentableId: this.currentBookingId
          }
        });
        await this.rejectBooking(this.currentBookingId);
        this.$emit("close");
        this.$emit("rejected");
        this.isLoading = false;
        this.description = "";
      }
    },
    cancel() {
      this.description = "";
      this.$refs.rejectBookingValidation.reset();
      this.$emit("close");
    }
  }
};
</script>

<style lang="scss"></style>
